import megatron, { get, megatronPostServerSide } from '../../../../../utils/megatron/megatron';
import { 
  SEO_QUERY_SUBMIT_API, 
  SEO_ROUTE_API, 
  SEO_CITY_API, 
  SEO_AIRPORT_CITY_API, 
  SEO_AIRPORT_ROUTE_API, 
  SEO_CAR_ROUTE_API, 
  SEO_RYDE_ROUTE_API, 
  SEO_CAR_RENTAL_API, 
  ONEWAY_INTERLINKING_API, 
  SEO_CAR_CITY_API, 
  WAY_TYPE_FROM, 
  WAY_TYPE_IN, 
  WAY_TYPE_TO, 
  provisionalDetailsHob, 
  GI_API_PREFIX, 
  cabConfigDataApi, 
  SEO_MULTICITY_URL, 
  fetchLocationDetails 
} from '../../../config/constants';
import { capitalizeFirstLetter } from '../../../config/utils';
import { getAddress } from '../../HouseOfBrands/utils';

const format = (response, way = '') => {
  const formattedResponse = {
    voy_data: {
      reviews: [],
    },
    lob_data: {
      safety_feed: {
        code: true
      },
      results: {},
      hideLob: false
    },
    common_data: {
      source: {},
      destination: {}
    },
    seo_meta: {},
    template: {
        faq: {},
        benefits: {},
        lpg: {},
        place_information: "",
        seo_content: "",
        templatized_content: "",
    },
    routes: {
        top_routes_from_src: [],
        top_routes_from_src_title: "",
        top_routes_to_dest: [],
        top_routes_to_dest_title: "",
        rental_data: []
    },
    routeInfo: {
      title: "",
      table: [],
    },
    interlinking: [],
    query_fields: [],
    showSEOLeadgen: false,
    days_offset: 3,
    package_carousel: [],
    selectedPackageId: '',
    selectedPackageTime: '',
    static_rental_data: [],
    static_table_data: [],
    static_rental_table_data: [],
    dynamic_footer_data: [],
    aggregate_ratings: {},
    schema_min_fare: -1,
    showInboundCall: false,
    contactNumber: '',
    seo_multi_city: false,
    showSEOLeaveIntentForm: false,
    couponData: null,
  };
  const { route_info_data, package_carousel, days_offset, voy_data, lob_data, seo_meta, template, top_routes_from_src, top_routes_from_src_title = "", top_routes_to_dest, top_routes_to_dest_title = "", canonical_url, reverse_slug, src_city, src_state, src_city_id, dest_city, dest_city_id, dest_state, city, city_id, city_state, rental_data, interlinks, query_params, showSeoLeadgen=false, static_rental_data, static_table_data, dynamic_footer_data, aggregate_ratings = {}, schema_min_fare = -1, seo_multi_city = false, showInboundCall = false, contactNumber = '', showLeaveIntentForm = false, couponInfo = null } = response;
  if(voy_data) {
    const { reviews } = voy_data;
    if (reviews && reviews.length > 0) {
      formattedResponse.voy_data['reviews'] = reviews;
    }
  }
  if (city && city_id) {
    if (way === WAY_TYPE_FROM || way === WAY_TYPE_IN ) {
      formattedResponse.common_data['source'] = { name: capitalizeFirstLetter(city), place_id: city_id, city_name: city, state: city_state  }
    } else if (way === WAY_TYPE_TO) {
      formattedResponse.common_data['destination'] = { name: capitalizeFirstLetter(city), place_id: city_id, city_name: city, state: city_state  }
    }
  }
  if (src_city && src_city_id) {
    formattedResponse.common_data['source'] = { name: capitalizeFirstLetter(src_city), place_id: src_city_id, city_name: '', state: src_state  }
  }
  if (dest_city && dest_city_id) {
    formattedResponse.common_data['destination'] = { name: capitalizeFirstLetter(dest_city), place_id: dest_city_id, state: dest_state }
  }
  if(lob_data && lob_data?.pkg_id) {
    const {pkg_id = "", pkg_data = {}} = lob_data;
    formattedResponse.selectedPackageId = pkg_id;
    lob_data.response = pkg_data?.response;
  }
  if(lob_data && lob_data?.response) {
    const { additional_info, srp_response } = lob_data?.response;
    if (additional_info && additional_info?.safety_feed && additional_info?.safety_feed?.node && additional_info?.safety_feed?.node?.length > 0) {
      formattedResponse.lob_data['safety_feed'] = additional_info?.safety_feed;
    }

    if (srp_response && srp_response?.common_data) {
      formattedResponse.lob_data['results'] = srp_response;
    }
  } else {
    formattedResponse.lob_data['hideLob'] = true;
  }
  if (seo_meta) {
    formattedResponse.seo_meta = { 
        ...seo_meta,
        canonical_url: canonical_url || '',
        alternate: voy_data?.android_link || '',
        reverse_slug: reverse_slug || '',
        sector: city ? `${capitalizeFirstLetter(city)}` : `${capitalizeFirstLetter(src_city)} - ${capitalizeFirstLetter(dest_city)}`,
        page: canonical_url ? canonical_url?.slice(0, canonical_url?.length - 1)?.replace('https://www.goibibo.com', '') : ''
    }
  }
  if (template) {
      const { faq, benefits, lpg, place_information, seo_content, templatized_content } = template;
      if (faq) {
        formattedResponse.template['faq'] = faq;
      }
      if (benefits) {
        formattedResponse.template['benefits'] = benefits;
      }
      if (lpg) {
        formattedResponse.template['lpg'] = lpg;
      }
      if (place_information) {
        formattedResponse.template['place_information'] = place_information;
      }
      if (seo_content) {
        formattedResponse.template['seo_content'] = seo_content;
      }
      if (templatized_content){
        formattedResponse.template['templatized_content'] = templatized_content;
      }
  }
  if (top_routes_from_src && top_routes_from_src?.length > 0) {
    formattedResponse.routes['top_routes_from_src'] = top_routes_from_src;
    formattedResponse.routes['top_routes_from_src_title'] = top_routes_from_src_title;
  }
  if (top_routes_to_dest && top_routes_to_dest?.length > 0) {
    formattedResponse.routes['top_routes_to_dest'] = top_routes_to_dest;
    formattedResponse.routes['top_routes_to_dest_title'] = top_routes_to_dest_title;
  }
  if (rental_data?.length > 0) {
    formattedResponse.routes['rental_data'] = rental_data;
  }
  if (interlinks?.length > 0) {
    formattedResponse.interlinking = interlinks;
  }
  if (query_params?.length > 0) {
    formattedResponse.query_fields = query_params;
  }
  formattedResponse.showSEOLeadgen = showSeoLeadgen;
  formattedResponse.showInboundCall = showInboundCall;
  formattedResponse.contactNumber = contactNumber;
  formattedResponse.showSEOLeaveIntentForm = showLeaveIntentForm;
  formattedResponse.couponData = couponInfo;
  if(package_carousel && package_carousel?.length > 0){
    formattedResponse.package_carousel = package_carousel
  }
  if(days_offset){
    formattedResponse.days_offset = days_offset;
  }

  if (static_rental_data) {
    formattedResponse.static_rental_data = static_rental_data;
    
    if (static_rental_data[0]?.pkg_data?.length) {
      const pkgData = []
      static_rental_data[0]?.pkg_data.forEach(data => {
        pkgData.push({...data, packageId : static_rental_data[0]?.pkg_id, packageTime : static_rental_data[0]?.time, is_static : static_rental_data[0]?.is_static})
      })
      
      formattedResponse.static_rental_table_data = pkgData
      formattedResponse.selectedPackageId = static_rental_data[0]?.pkg_id
      formattedResponse.selectedPackageTime = static_rental_data[0]?.time
    }
  }

  if (static_table_data) {
    formattedResponse.static_table_data = static_table_data?.cabs
  }

  if (dynamic_footer_data && dynamic_footer_data?.length) {
    formattedResponse.dynamic_footer_data = dynamic_footer_data
  }

  if (Object.keys(aggregate_ratings)?.length > 0) {
    formattedResponse['aggregate_ratings'] = aggregate_ratings
  }

  if (schema_min_fare > 0) {
    formattedResponse['schema_min_fare'] = schema_min_fare
  }

  if(route_info_data?.table?.length){
    formattedResponse.routeInfo.title = route_info_data?.title;
    formattedResponse.routeInfo.table = route_info_data?.table;
  }

  formattedResponse["seo_multi_city"] = seo_multi_city;

  return formattedResponse;
}

export const fetchSeoRentalData = async (city, way, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_CAR_RENTAL_API}?city=${city}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }
  try {
    const response = await get(url, {
      name: 'cars-seo-rental'
    });
    if (response?.data && response?.data?.status && !response?.data?.error_message) {
      return format(response?.data?.data, 'in');
    } else {
      // For setting Cache to false
      throw `API ERROR - ${response?.data?.error_message}`;
    }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchSeoAirportCityData = async (city, way, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_AIRPORT_CITY_API}?city=${city}&way=${way}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }
  try {
    const response = await get(url, {
      name: 'cars-seo-airport-city'
    });
  if (response?.data && response?.data?.status && !response?.data?.error_message) {
    return format(response?.data?.data, way);
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchSeoAirportRouteData = async (params, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_AIRPORT_ROUTE_API}?params=${params}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }
  try {
    const response = await get(url, {
      name: 'cars-seo-airport-route'
    });
  if (response?.data && response?.data?.status && !response?.data?.error_message) {
    return format(response?.data?.data);
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchSeoCityData = async (city, way, hardReloadFlag = false) => {
	let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_CITY_API}?city=${city}&way=${way}`;
  
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }

  try {
    const response = await get(url, {
      name: 'cars-seo-city'
    });
    if (response?.data && response?.data?.status && !response?.data?.error_message) {
      return format(response?.data?.data, way);
    } else {
      // For setting Cache to false
      throw `API ERROR - ${response?.data?.error_message}`;
    }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchSeoRouteData = async (src, dest, hardReloadFlag = false) => {
    let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_ROUTE_API}?src=${src}&dest=${dest}`;
    if (hardReloadFlag) {
      url = url + `&hcb=${hardReloadFlag}`;
    }
    try {
      const response = await get(url, {
        name: 'cars-seo-route'
      });

     
    if (response?.data && response?.data?.status && !response?.data?.error_message) {
      return format(response?.data?.data);
    } else {
      // For setting Cache to false
      throw `API ERROR - ${response?.data?.error_message}`;
    }
    } catch (err) {
        // For setting Cache to false
        console.info("err", err);
        throw err;
    }
};

export const fetchCharDhamRouteData = async () => {
  try {
    const response = await get(SEO_MULTICITY_URL,{
      name:"char-dham-route"
    });
    const charDhamData = {
      dhamInfo: response?.data?.dhamInfo,
      itineraryInfo: response?.data?.itineraryInfo,
      packages: response?.data?.packages,
      thingToKeepInMind: response?.data?.thingToKeepInMind,
      whyChooseUs: response?.data?.whyChooseUs,
      source: response?.data?.source,
      destination: response?.data?.destination,
    };

    const formattedResponse = {
      charDhamData,
      seo_meta:response?.data?.giInfo,
      source:response?.data?.source?.name,
      destination:response?.data?.destination.name,
      sourceData:response?.data?.source,
      destinationData:response?.data?.destination,
      faqs:response?.data?.faqInfo,
    }
    return formattedResponse;
  } catch (err) {
      console.info("err", err);
      throw err;
  }
}

export const fetchSeoRydeRouteData = async (src, dest, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_RYDE_ROUTE_API}?src=${src}&dest=${dest}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }
  try {
    const response = await get(url, {
      name: 'cars-seo-route-ryde'
    });
  if (response?.data && response?.data?.status && !response?.data?.error_message) {
    return format(response?.data?.data);
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};
export const fetchSeoCarSpecificRouteData = async (src, dest, carType, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_CAR_ROUTE_API}?src=${src}&dest=${dest}&car_type=${carType}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }
  try {
    const response = await get(url, {
      name: 'cars-seo-route'
    });
  if (response?.data && response?.data?.status && !response?.data?.error_message) {
    return format(response?.data?.data);
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchSeoCarSpecificCityData = async (src, carType, way, hardReloadFlag = false) => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${SEO_CAR_CITY_API}?city=${src}&car_type=${carType}`;
  if (hardReloadFlag) {
    url = url + `&hcb=${hardReloadFlag}`;
  }

  try {
    const response = await get(url, {
      name: 'cartype-seo-city'
    });
    if (response?.data && response?.data?.status && !response?.data?.error_message) {
      return format(response?.data?.data, way);
    } else {
      // For setting Cache to false
      throw `API ERROR - ${response?.data?.error_message}`;
    }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const fetchOneWayCabInterlinkingData = async () => {
  let url = `${__ENV_CONFIG__['__PAGEROVER__']}${ONEWAY_INTERLINKING_API}`;
  try {
    const response = await get(url, {
      name: 'one-way-cab'
    });
  if (response?.data && response?.data?.status && !response?.data?.error_message) {
    return response?.data?.data;
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.info("err", err);
      throw err;
  }
};

export const submitQuerydetails = async (queryDetails) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${SEO_QUERY_SUBMIT_API}`;
  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json'
  };
  const data = { ...queryDetails }
  try {
    const response = await megatron({
      name: 'cars-seo-route_querydetails',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });
    return response?.response ? response.response : response
  } catch (err) {
    console.info("err", err);
    throw err;
  }
};

export const fetchCabConfigData = async () => {
  let url = `${__ENV_CONFIG__['__GOCARS__']}${cabConfigDataApi}`;
  try {
    const response = await get(url, {
      name: 'cab-config'
    });

  if (response?.data?.data ) {
    return response?.data?.data;
  } else {
    // For setting Cache to false
    throw `API ERROR - ${response?.data?.error_message}`;
  }
  } catch (err) {
      // For setting Cache to false
      console.debug("err ===========>>>>>>>>", err);
      throw err;
  }
};


export const getPageLoadHOBData = async (request, orgId) => {
  const url = orgId === "MMT" ? `${__ENV_CONFIG__['__MMT__']}${provisionalDetailsHob}` : `${__ENV_CONFIG__['__GOCARS__']}${GI_API_PREFIX}${provisionalDetailsHob}`

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    'content-type': 'application/json'
  }

  const data = {
    ...request
  }

  try {
    const respJson : any = await megatronPostServerSide({
      name: 'cars_prov_hob',
      type: 'POST',
      credentials: 'include',
      url,
      requestData: JSON.stringify(data),
      headers
    });
    if (respJson?.error && !respJson?.errors) {
        return {
            errors: {
                error_list: [{
                    code: "PROVISIONAL_API_ERROR_CODE",
                    message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
                }]
            }
        }
    }

    return respJson
  } catch (err) {
    return {
        errors: {
            error_list: [{
                code: "PROVISIONAL_API_ERROR_CODE",
                message: "This seems wierd, We are looking into it meanwhile please click below for creating a new cab booking."
            }]
        }
    }
  }
}

export const getPlaceDetailsServerSide = async (placeId) => {
  const url = `${__ENV_CONFIG__['__GOCARS__']}${fetchLocationDetails}=${placeId}`;

  const headers = {
    Authorization: "Basic Zm9vOmJhcg==",
    "content-type": "application/json"
  };

  try {
    const response: any = await megatronPostServerSide({
      name: "cars place details server",
      type: "GET",
      credentials: 'include',
      url,
      headers
    });
    const results = response?.results || [];
    const [result] = results;
    return getAddress(result);
  } catch (err) {
    console.info("err", err);
    return {};
  }
};
